// Popup: chỉ còn xử lý đóng popup bằng nút X / lớp nền mờ.
//
// Popup Đổi Tướng để cứng trong HTML: 4 bộ thẻ của 4 phe render sẵn, bộ không
// hiện thì display:none ngay trong markup. Landing KHÔNG đổi tab, KHÔNG đổi ảnh
// thẻ, KHÔNG bật tắt is-checked nữa — backend tự xử lý khi có dữ liệu người chơi.
//
// Tỉ lệ thu nhỏ popup trên màn dọc chốt cứng trong SCSS (--popup-scale-fit),
// không tính bằng JS. Nếu sau này cần tự co theo bề ngang máy thì đọc
// --popup-width/--popup-height (KHÔNG dùng offsetWidth: popup đang display:none
// trả về 0, phép chia ra Infinity và trình duyệt bỏ luôn transform).

window.addEventListener("load", function () {
  document.querySelectorAll(".MJ__close-popup").forEach(function (button) {
    button.addEventListener("click", function () {
      const popup = button.closest(".MS__popup");
      if (!popup) return;
      popup.classList.remove("active");
      if (window.location.hash === "#" + popup.id) {
        window.location.hash = "#";
      }
    });
  });
});
